import * as Sentry from "@sentry/browser";
import { Dedupe } from "@sentry/integrations";

const SENTRY_SERVER_URL =
  "https://80e9e2c07f554c7d9483d7fd25ef960a@o208877.ingest.sentry.io/5254754";

// Error on iOS Chromium browsers for unwrapped in <form> <fieldset> tag
const UNOWNED_AUTOFILLABLE_FORM_FIELD =
  "getUnownedAutofillableFormFieldElements";
// Errors than shouldn't be send to Sentry
const IGNORE_ERRORS = [UNOWNED_AUTOFILLABLE_FORM_FIELD];

const initErrorLogging = () => {
  const isEnabled = process.env.REACT_APP_SENTRY_ENABLED === "true";
  if (isEnabled) {
    Sentry.init({
      dsn: SENTRY_SERVER_URL,
      integrations: [new Dedupe()],
      beforeSend(event) {
        const {
          exception: { values },
        } = event;

        const firstValue = values && values[0];
        const errorMessage = (firstValue && firstValue.value) || "";

        if (IGNORE_ERRORS.some((error) => errorMessage.includes(error))) {
          return null;
        }
      },
    });
  }
};

export default initErrorLogging;
